import { render, staticRenderFns } from "./BuyCompleted.vue?vue&type=template&id=54d9ee27&scoped=true&lang=pug&"
import script from "./BuyCompleted.vue?vue&type=script&lang=js&"
export * from "./BuyCompleted.vue?vue&type=script&lang=js&"
import style0 from "./BuyCompleted.vue?vue&type=style&index=0&id=54d9ee27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d9ee27",
  null
  
)

export default component.exports